<template>
  <div>
    <v-tooltip bottom >
      <template v-slot:activator="{ on, attrs }">
        <a-btn
          x-small
          color="primaryDark"
          width="24"
          min-width="24"
          v-on="on"
          v-bind="attrs"
          :disabled="isMeetingModified"
          @click="openMettingListDialog"
          class="mt-2"
        >
          <v-icon size="16" color="#fff"> mdi-export</v-icon>
        </a-btn>
      </template>
      <span> {{ $t("agenda.tipMoveTopic") }} </span>
    </v-tooltip>
    <a-dialog v-model="isOpen" max-width="500px" scrollable persistent>
      <v-card>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1">
            <span> {{ $t("dashboard.lblUpcomingMeetings") }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="isOpen = false" />
          </v-toolbar>
        </v-banner>
        <v-card-text class="pa-0">
          <Loader :loading="Loaderloading" :message="LoaderText"></Loader>
          <v-skeleton-loader
            v-if="Loaderloading"
            type="list-item-two-line, list-item-two-line, article, list-item"
          ></v-skeleton-loader>
          <a-list
            v-else
            class="meeting-list list-margin pt-0"
            style="overflow: auto"
          >
            <v-list-item-group
              v-if="upCommingMeetingData.length > 0"
              v-model="selectedMeetingItem"
              color="primary"
            >
              <v-list-item
                v-for="(meetingItem, index) in upCommingMeetingData"
                :key="index"
                :value="meetingItem"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ meetingItem.meetingName }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ getDay(meetingItem.scheduletStartTimeInUTC) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
            <v-list-item v-else>
              <v-list-item-content>
                <v-list-item-title class="caption">
                  {{ $t("agenda.msgNoUpcomingMeetingFound") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </a-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                color="primaryDark"
                class="mr-2"
                @click.stop="moveTopicToMeeting"
                :disabled="!selectedMeetingItem"
              >
                {{ $t("agenda.btnMove") }}
              </a-btn>
            </template>
            <span>{{ $t("agenda.btnMove") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                color="secondary"
                @click="close"
                >{{ $t("btnClose") }}</a-btn
              >
            </template>
            <span>{{ $t("btnClose") }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </a-dialog>
    <confirm-dialog ref="confirm"></confirm-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";
import Loader from "@/components/Loader.vue";
Vue.prototype.$eventHub = new Vue();
export default {
  components: { ConfirmDialog, Loader },
  name: "TopicMoveMeetingList",
  props: {
    selectedMeeting: {
      type: Object,
      default: null,
    },
    topic: Object,
    isMeetingModified: Boolean,
  },
  data() {
    return {
      selectedMeetingItem: null,
      isOpen: false,
      Loaderloading: false,
    };
  },
  computed: {
    ...gettersMap(),
    LoaderText() {
      return this.$t("LoaderText");
    },
    meetingObject: {
      get() {
        return this.selectedMeeting;
      },
      set(val) {
        this.selectedMeeting = val;
      },
    },
    upCommingMeetingData() {
      if (!this.getUpcommingMeetings) return [];

      const { id: currentMeetingId, meetingTypeId: currentMeetingTypeId } =
        this.meetingObject;

      // Filter meetings that don't match the current meeting ID and have the same type
      const upCommingMeetingList = this.getUpcommingMeetings.filter(
        (meeting) =>
          meeting.id !== currentMeetingId &&
          String(meeting.meetingTypeId).toLowerCase() ===
            String(currentMeetingTypeId).toLowerCase()
      );

      // Sort the filtered meetings by scheduled start time in ascending order
      const sortedMeetingList = _.orderBy(
        upCommingMeetingList,
        ["scheduletStartTimeInUTC"],
        ["asc"]
      );

      // Select the first meeting in the sorted list
      this.selectedMeetingItem = sortedMeetingList[0] || null;

      return sortedMeetingList;
    },
  },
  methods: {
    ...mapActions({
      getUpcomingMeetingList: "meeting/getUpcomingMeetingList",
      validateMoveMeetingTopic: "meeting/validateMoveMeetingTopic",
    }),
    openMettingListDialog,
    getDay,
    close,
    moveTopicToMeeting,
    moveTopic,
    addTopicToSelectedMeeting,
    isTopicExistInUpcomingMeeting,
  },
};

function moveTopic() {
  const { agenda, ...topic } = this.topic;

  // Update documents with the selected meeting ID
  topic.documents =
    topic.documents?.map((document) => ({
      ...document,
      meetingid: this.selectedMeetingItem.id,
    })) || [];

  // Reset people in charge for the topic
  topic.peopleInCharge = [];

  // Initialize movedTopicList if undefined
  this.selectedMeeting.movedTopicList ??= [];

  // Find or create moveObject for the selected meeting
  const moveObject = this.selectedMeeting.movedTopicList.find(
    (m) => m.meetingId === this.selectedMeetingItem.id
  );

  if (moveObject) {
    moveObject.topics.push(topic);
  } else {
    this.addTopicToSelectedMeeting(topic);
  }

  // Emit event and close
  this.$emit("onConfirmMove");
  this.$eventHub.$emit("onTopicMovie");
  this.close();
}

function addTopicToSelectedMeeting(topic) {
  const movedTopicObject = {
    topics: [topic],
    meetingId: this.selectedMeetingItem.id,
  };

  this.selectedMeeting.movedTopicList.push(movedTopicObject);
}

async function moveTopicToMeeting() {
  const userConfirmed = await this.$refs.confirm.open(
    this.$t("agenda.hMoveTopic"),
    this.$t("agenda.lblMoveTopic"),
    { yesNoButtons: true }
  );

  if (userConfirmed) {
    this.moveTopic();
  }
}

async function isTopicExistInUpcomingMeeting() {
  const params = {
    next_meeting_id: this.selectedMeetingItem.id,
    topic_id: this.topic.Id,
  };
  const result = await this.validateMoveMeetingTopic(params);
  return result.data.topic_present;
}

async function openMettingListDialog() {
  if (this.isMeetingModified) {
    const confirmDialog = await this.$refs.confirm.open(
      this.$t("agenda.tipMoveTopic"),
      this.$t("agenda.moveTopicConfirmationMessage"),
      {
        yesNoButtons: true,
        dialogIcon: "alert",
      }
    );

    if (confirmDialog) {
      this.$eventHub.$emit("onSaveMeeting");
    }
    return;
  }

  this.isOpen = true;

  if (this.meetingObject.meetingTypeId) {
    this.Loaderloading = true;
    try {
      const params = {
        meeting_type_id: this.meetingObject.meetingTypeId,
        topic_id: this.topic.Id,
      };
      await this.getUpcomingMeetingList(params);
    } finally {
      this.Loaderloading = false;
    }
  }
}

function getDay(meetingdate) {
  var Xmas95 = new Date(meetingdate);
  var options = { dateStyle: "full", timeStyle: "short" };
  return new Intl.DateTimeFormat(this.$i18n.locale, options).format(Xmas95);
}

function close() {
  this.selectedMeetingItem = null;
  this.isOpen = false;
}

function gettersMap() {
  return mapGetters({
    getFilteredResultApi: "meeting/getFilteredResult",
    getUpcommingMeetings: "meeting/getUpcommingMeetings",
  });
}
</script>

<style scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>